/**
 * Shared utilities for task actions
 */

// Helper to get taskId from dependency (handles both string and object format)
export const getDependencyTaskId = (dep) => {
  if (typeof dep === 'string') return dep;
  return dep?.taskId || null;
};

// Helper to filter out dependencies by taskId
export const filterDependencies = (deps, taskIdToRemove) => {
  if (!Array.isArray(deps)) return [];
  return deps.filter(dep => getDependencyTaskId(dep) !== taskIdToRemove);
};

// Generate unique task ID
export const generateTaskId = () => `task-${Date.now()}`;

